import React from "react";

import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";

export default function ReleaseHealthAboutView() {
  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          About
        </Heading>
        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          What it measures
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "A single 0–10 score summarizing the overall state of a release, derived from six weighted sub-metrics covering stability, reliability, performance, test coverage, and defect handling."
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          Why it matters
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            'Tech leads juggle dozens of signals before calling a build "ready" or a production release "healthy." Release health collapses those into one number that\'s defensible in a standup, a Slack thread, or a go/no-go call. Every input is a leading or lagging indicator of user-facing quality — none of them are vanity.'
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          How to use it
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "Aim high and drill into the lowest-scoring contributor first — that's where you'll get the biggest lift for the least effort. Re-weight the inputs to match what your team actually cares about; the defaults are a sensible starting point, not a verdict."
          }
        </Paragraph>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
